// extracted by mini-css-extract-plugin
export default {"zoomModal":"S2-z"};